module.exports = __webpack_public_path__ + "img/disabled_currency.18d3f0c9.svg";